import React from 'react'
import sadFace from "../../assets/svgs/smiling-tear.svg"

const Activities = () => {
  return (
    <div className='w-[80%] h-[95%] bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] mx-auto rounded-2xl px-5'>
        <p className='mt-4 font-light text-base text-main-blue'>My activities</p>
        <div className = "flex flex-col justify-around items-center h-[90%]">
          <div className = "flex flex-col gap-3 items-center">
          <img src = {sadFace} alt="sad face"/>
          <p className = "font-light text-sm text-[#EC6060]">Whoopsie daisy! Looks like </p>
          <p className = "font-light text-sm text-[#EC6060] mt-[-3%]">there's nothing to review just yet.</p>
          </div>
        </div>
    </div>
  )
}

export default Activities